<template>
  <div class="admin-login">
    <div class="login-box">
      <div class="login-icon">🔐</div>
      <h1>Back-Office Admin</h1>
      <p class="subtitle">Fidélité Marché</p>

      <div class="form-group">
        <label class="label">Login</label>
        <input v-model="login" class="input" placeholder="admin" @keyup.enter="connect" />
      </div>
      <div class="form-group">
        <label class="label">Mot de passe</label>
        <input v-model="password" class="input" type="password" placeholder="••••••••" @keyup.enter="connect" />
      </div>

      <p v-if="erreur" class="error">{{ erreur }}</p>

      <button class="btn btn-primary" @click="connect" :disabled="loading">
        {{ loading ? 'Connexion...' : 'Se connecter' }}
      </button>
    </div>
  </div>
</template>

<script>
import adminApi from '../../adminApi'

export default {
  name: 'AdminLogin',
  data() { return { login: '', password: '', erreur: '', loading: false } },
  methods: {
    async connect() {
      this.erreur  = ''
      this.loading = true
      try {
        const res = await adminApi.post('/login', { login: this.login, password: this.password })
        localStorage.setItem('admin_token', res.data.token)
        this.$router.push('/admin/dashboard')
      } catch (err) {
        this.erreur = err.response?.data?.error || 'Identifiants incorrects'
      } finally { this.loading = false }
    }
  }
}
</script>

<style scoped>
.admin-login { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: linear-gradient(135deg, #1a202c 0%, #2d3748 100%); }
.login-box { background: white; border-radius: 20px; padding: 40px; width: 100%; max-width: 400px; text-align: center; box-shadow: 0 20px 60px rgba(0,0,0,0.3); }
.login-icon { font-size: 48px; margin-bottom: 12px; }
h1 { font-size: 22px; font-weight: 700; color: #2d3748; margin-bottom: 4px; }
.subtitle { color: #718096; font-size: 14px; margin-bottom: 28px; }
.form-group { text-align: left; margin-bottom: 16px; }
.label { display: block; font-size: 13px; font-weight: 600; color: #4a5568; margin-bottom: 6px; }
.input { width: 100%; padding: 12px 16px; border: 1.5px solid #e2e8f0; border-radius: 10px; font-size: 15px; outline: none; }
.input:focus { border-color: #4a5568; }
.error { color: #e53e3e; font-size: 13px; margin-bottom: 12px; }
.btn { width: 100%; padding: 14px; border: none; border-radius: 10px; font-size: 15px; font-weight: 600; cursor: pointer; }
.btn-primary { background: #2d3748; color: white; }
.btn-primary:hover { background: #1a202c; }
.btn-primary:disabled { background: #a0aec0; cursor: not-allowed; }
</style>
